import superMeta from '../_DES_CAT/metaDesCatNode.mjs'

export default {
    ...superMeta,
    name: '业务需求',
    type: 'DES_TASK',
}
